<script>
import Vue from 'vue';

export default Vue.extend({});
</script>
<template>
    <div class="not-found-container">
        {{ $t('notFound.heading') }}
    </div>
</template>



// WEBPACK FOOTER //
// src/components/NotFoundContainer/NotFoundContainer.vue